(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    (function () {
    function composeJoinListBody(form) {
      var header = '--- Early access / join the list ---';
      var street = (form.querySelector('[data-rs-join-field="street"]') || {}).value || '';
      var suburb = (form.querySelector('[data-rs-join-field="suburb"]') || {}).value || '';
      var postcode = (form.querySelector('[data-rs-join-field="postcode"]') || {}).value || '';
      var pup = (form.querySelector('[data-rs-join-field="pup_parent"]') || {}).value || '';
      var dog = (form.querySelector('[data-rs-join-field="dog_name"]') || {}).value || '';
      var lines = [
        header,
        'Street address: ' + street.trim(),
        'Suburb: ' + suburb.trim(),
        'Postcode: ' + postcode.trim(),
        'SohaliSpirit pup parent: ' + pup.trim(),
        "Dog's name: " + dog.trim(),
      ];
      var bodyEl = form.querySelector('[name="contact[body]"]');
      var optional = bodyEl ? bodyEl.value.trim() : '';
      if (optional) {
        lines.push('', 'Additional note:', optional);
      }
      return lines.join('\n');
    }

    function fieldValue(form, selector) {
      var el = form.querySelector(selector);
      return el ? (el.value || '').trim() : '';
    }

    // Fire-and-forget POST to the approval Worker (App Proxy) so the customer
    // is created/tagged `access-requested` and Shopify Flow can email Kristie
    // the Approve/Wait-list/Reject links. The native contact form still submits
    // independently, so a request is never lost if this beacon fails or the
    // Worker is briefly down. Keys are camelCase to match the Worker parser
    // (#187). Only fires on the join-list (Request Access) form.
    function sendAccessBeacon(form, optionalNote) {
      if (!('sendBeacon' in navigator)) return;
      var first = fieldValue(form, '[data-rs-join-field="first"]');
      var last = fieldValue(form, '[data-rs-join-field="last"]');
      var email = fieldValue(form, '[name="contact[email]"]');
      if (!email) return;
      var fd = new FormData();
      fd.append('email', email);
      fd.append('firstName', first);
      fd.append('lastName', last);
      fd.append('phone', fieldValue(form, '[name="contact[phone]"]'));
      fd.append('street', fieldValue(form, '[data-rs-join-field="street"]'));
      fd.append('suburb', fieldValue(form, '[data-rs-join-field="suburb"]'));
      fd.append('postcode', fieldValue(form, '[data-rs-join-field="postcode"]'));
      fd.append('pupParent', fieldValue(form, '[data-rs-join-field="pup_parent"]'));
      fd.append('dogName', fieldValue(form, '[data-rs-join-field="dog_name"]'));
      fd.append('note', optionalNote || '');
      try {
        navigator.sendBeacon('/apps/portal/access-request', fd);
      } catch (e) {
        /* non-blocking: native form still delivers the submission */
      }
    }

    function onJoinListSubmit(event) {
      var form = event.target;
      if (!form.classList.contains('contact-form__form')) return;
      if (!form.classList.contains('contact-form__form--join-list')) return;

      var first = (form.querySelector('[data-rs-join-field="first"]') || {}).value || '';
      var last = (form.querySelector('[data-rs-join-field="last"]') || {}).value || '';
      var nameHidden = form.querySelector('[data-rs-join-name-hidden]');
      if (nameHidden) {
        nameHidden.value = (first.trim() + ' ' + last.trim()).trim();
      }
      var bodyEl = form.querySelector('[name="contact[body]"]');
      // Capture the customer's optional note BEFORE composeJoinListBody
      // overwrites contact[body] with the full composed block.
      var optionalNote = bodyEl ? bodyEl.value.trim() : '';
      sendAccessBeacon(form, optionalNote);
      if (bodyEl) {
        bodyEl.value = composeJoinListBody(form);
      }
    }

    document.addEventListener('submit', onJoinListSubmit, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["partner-form"] && !Shopify.designMode) return;
  try {
    (function () {
    function compose(form) {
      function val(sel) {
        var el = form.querySelector('[data-rs-partner-field="' + sel + '"]');
        return el ? (el.value || '').trim() : '';
      }
      var lines = [
        '--- Partner / wholesale enquiry ---',
        'Business / kennel: ' + val('business'),
        'Contact name: ' + val('contact_name'),
        'Business type: ' + val('business_type'),
        'Products of interest: ' + val('products'),
        'Estimated monthly volume: ' + val('volume'),
        'ABN: ' + val('abn'),
      ];
      var bodyEl = form.querySelector('[name="contact[body]"]');
      var msg = bodyEl ? bodyEl.value.trim() : '';
      if (msg) lines.push('', 'Message:', msg);
      return lines.join('\n');
    }

    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form.classList || !form.classList.contains('partner-form__form')) return;
        var business = (form.querySelector('[data-rs-partner-field="business"]') || {}).value || '';
        var contact = (form.querySelector('[data-rs-partner-field="contact_name"]') || {}).value || '';
        var nameHidden = form.querySelector('[data-rs-partner-name-hidden]');
        if (nameHidden) nameHidden.value = (business.trim() + ' / ' + contact.trim()).replace(/^ \/ | \/ $/g, '').trim();
        var bodyEl = form.querySelector('[name="contact[body]"]');
        if (bodyEl) bodyEl.value = compose(form);
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
